module.exports = __webpack_public_path__ + "static/media/bg3.6483de62.png";